export const funnelCopy = {
  role: {
    title: "What sort of job is it?",
    intro: "Pick the role that matches this job. We'll use it to set the right CDM duties.",
    options: [
      {
        value: "RUNNING_THE_JOB",
        title: "I'm running this job",
        body: "Use this when you are acting as the main contractor or coordinating the work.",
      },
      {
        value: "SOLO_TRADER",
        title: "It's just me or my team",
        body: "Use this for smaller jobs where you still need proper RAMS, CPP and site records.",
      },
      {
        value: "SOMEONE_ELSES_JOB",
        title: "I'm working on someone else's job",
        body: "Use this when you need documents for your part of a wider project.",
      },
    ],
    continue: "Continue to the job details",
  },
  brief: {
    title: "Add the job details",
    intro: "Fill this in yourself, or upload a PDF and check what we find.",
    save: "Save this project",
    fields: {
      title: {
        label: "Project name",
        why: "This becomes the heading on your project workspace and document pack.",
      },
      siteAddress: {
        label: "Site address",
        why: "The site address appears on the CPP, RAMS and induction records.",
        // Issue #2126: shown only when the typed address has no postcode in it.
        // A nudge, never a block — pricing a job before the postcode is known
        // is normal, and the one thing the postcode helps with (the nearest
        // A&E) is asked for again in Site Safety Setup if it is still missing.
        postcodeNudge:
          "No postcode yet? Carry on without it — add it later and we can find your nearest A&E for the emergency plan.",
      },
      domesticClient: {
        label: "Is this someone's home?",
        why: "Domestic work changes how CDM duties are assigned.",
      },
      estimatedDuration: {
        label: "Estimated duration",
        why: "Duration helps shape the CPP timeline and site controls.",
      },
      scopeDescription: {
        label: "What work are you doing?",
        why: "The scope drives hazards, method statements and the first document outline.",
      },
    },
  },
  progress: {
    shell: "Project shell created",
    site: "Site details captured",
    domestic: "Domestic/non-domestic logic applied",
    structure: "Initial CPP structure preparing",
    hazards: "Hazard suggestions preparing",
  },
  save: {
    title: "Create your account to save",
    intro: "Set up your login and we will keep this draft ready on any device.",
    company: {
      // Issue #2126. The old heading asked WHOSE company went on the
      // documents — a question a reader pricing a job for a client can answer
      // with the client's. The heading now states the answer instead, and every
      // line below anchors it to the reader's own firm: this
      // value is stamped into the header of every document the account ever
      // generates, so an ambiguity here is a compliance defect, not a typo.
      title: "Add your company details",
      intro:
        "These print in the header of every document you generate, so they need to be your own firm — the contractor issuing the paperwork, not the client and not the site.",
      fields: {
        companyName: {
          label: "Your company name",
          // Every field says WHERE the value lands. The company address used to
          // default from the site address with no such line, so nothing on
          // screen told a visitor the two were different things.
          why: "Printed at the top of every RAMS, CPP, induction and emergency plan you generate.",
          placeholder: "Oak Lane Builders Ltd",
        },
        companyAddress: {
          label: "Your company address",
          why: "Your own trading address — not the site address. It prints under your company name in the document header.",
          placeholder: "Unit 3, Trade Park, Bristol BS1 4ST",
        },
      },
      continue: "Continue to create account",
      edit: "Edit",
      // "Saved for", not "will show": the claim fills BLANK profile fields
      // only, so a signed-in claimant whose account already holds company
      // details keeps them — an unconditional "your documents will show X"
      // would be false for that cell.
      summaryPrefix: "Saved for your documents:",
      addDetails: "Add company details",
      skipAfterError: "Continue without saving — you can add this in Settings later",
      errors: {
        nameRequired: "Add your company name to continue.",
        addressRequired: "Add your own company address to continue.",
        saveFailed:
          "We could not save your company details. Check your connection and try again.",
      },
    },
  },
} as const;

